import { computedAsync } from '@vueuse/core';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { checkAccess } from './checkAccess';

export const useAccess = (permissions: MaybeRefOrGetter<string[]>) => {
  const result = computedAsync(() => checkAccess(toValue(permissions)), {
    access: 'pending',
    permissions: {
      granted: [],
      denied: [],
    },
  });

  const access = computed(() => result.value.access);

  return {
    access,
    granted: computed(() => access.value === 'granted'),
    denied: computed(() => access.value === 'denied'),
    pending: computed(() => access.value === 'pending'),
    permissions: computed(() => ({
      granted: result.value.permissions.granted,
      denied: result.value.permissions.denied,
    })),
    resolutions: computed(() => result.value.resolutions),
  };
};
